import React from "react";
import { Question } from "../../models/Question";
import EAModal from "../shared/Modal/EAModal";
import { useTranslation } from "react-i18next";
import "./style/QuestionsModal.scss";
import EATextField from "../shared/TextField/EATextField";
import EAAlert from "../shared/EAAlert";

interface IProps {
  questions: Question[];
  onClose: () => void;
  onAnswer: (surveyIds: string, question: string, answer: string) => void;
  onSaveAnswers: () => Promise<void>;
  loading: boolean;
  saveError?: string;
}

const QuestionsModal: React.FC<IProps> = ({ questions, onClose, onAnswer, onSaveAnswers, loading, saveError }) => {
  const { t } = useTranslation();

  return (
    <EAModal isOpen onClose={onClose} title={t("odpowiedz_na_pytania")} loading={loading} onAccept={onSaveAnswers}>
      <div className="questions-modal-container">
        <EAAlert type="warning" message={t("jeden_z_asortymentow_ktore_zostaly_dodane_do_koszyka")} />
        {questions.map((q) => (
          <div key={`${q.question}-${q.surveyIds}`}>
            <EATextField
              fullWidth
              name={`${q.surveyIds}-${q.question}`}
              label={q.question}
              value={q.answer}
              onChange={(e) => onAnswer(q.surveyIds, q.question, e.target.value)}
              helperText={`${t("Pytanie dotyczy asortymentu")}: ${q.assortName}`}
            />
          </div>
        ))}
        {saveError && <EAAlert type="error" message={saveError} />}
      </div>
    </EAModal>
  );
};

export default QuestionsModal;
